/**
 * AuthGuard — redireciona para /login se o usuário não tem JWT na sessão.
 * Preserva a rota tentada via `state.from` para o LoginPage poder
 * devolver ao usuário onde ele queria chegar (UX padrão SPA). // ux-neutrality:allow doc-comment
 */
import { type ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSessionStore } from '@/stores/session';

/**
 * O endereço do caso que o QR do exame imprime (`/casos/{id}`). Sem sessão, ele leva ao login no
 * modo do código enviado ao e-mail (ajuste do owner 03/11, ADR-0149). // ux-neutrality:allow doc-comment
 */
const ENDERECO_DO_QR =
  /^\/casos\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?$/i;

export function AuthGuard({ children }: { children: ReactElement }): ReactElement {
  const token = useSessionStore((s) => s.token); // ux-neutrality:allow auth-token
  const location = useLocation();
  if (!token /* ux-neutrality:allow auth-token */) {
    const modo = ENDERECO_DO_QR.test(location.pathname) ? { modo: 'codigo' } : {};
    return <Navigate to="/login" replace state={{ from: location.pathname, ...modo }} />;
  }
  return children;
}
